export enum CustomerSettingType {
  Standard = 0,
  CustomerSpecific = 1,
}

export enum CustomerFormSections {
  General,
  Invoicing,
}
